import styled, {css} from 'styled-components';

import {colors, inputFieldBase, textEllipsis, transition} from 'theme';

export const TextareaContainer = styled.span`
    position: relative;
    display: block;
    width: 100%;
`;

export const TextareaElem = styled.textarea<{
    hasError?: boolean;
    disabled?: boolean;
    updatedStyle?: boolean;
}>`
    ${textEllipsis};
    ${(p) => inputFieldBase(p.disabled ? 'disabled' : p.hasError ? 'error' : 'normal')};

    display: block;
    width: 100%;
    box-sizing: border-box;
    height: 80px;
    cursor: ${(p) => (p.disabled ? 'not-allowed' : 'text')};
    transition: border-color ${transition.duration};
    resize: none;
    white-space: normal;
    overflow-y: auto;
    padding: 8px;

    &::-webkit-input-placeholder {
        color: ${colors.textSecondary};
    }

    &::-moz-placeholder {
        color: ${colors.textSecondary};
    }

    &:-ms-input-placeholder {
        color: ${colors.textSecondary};
    }

    &::-ms-input-placeholder {
        color: ${colors.textSecondary};
    }

    &::-ms-clear {
        display: none;
    }

    ${(p) =>
        p.updatedStyle &&
        css`
            padding: 16px;

            &::-webkit-input-placeholder {
                color: #1d222980;
            }

            &::-moz-placeholder {
                color: #1d222980;
            }

            &:-ms-input-placeholder {
                color: #1d222980;
            }

            &::-ms-input-placeholder {
                color: #1d222980;
            }
        `}
`;
